export enum DealSourceProvider {
  ROUTE_ONE = 'route_one',
  DEALER_TRACK = 'dealer_track',
}
